module.exports = __webpack_public_path__ + "img/onair-bgimg.c0c6daec.jpg";